module.exports = __webpack_public_path__ + "imgs/ernest-toney.dc19775a58cb0b03c65511989c25db6d.jpg";